<div class="bg" (click)="close()">
  <img class="photo" [src]="src" alt="">
</div>
